import React, { PureComponent, Component } from 'react';
import { Checkbox } from 'antd';
import { cloneDeep } from 'lodash';
import './index.less';
const CheckboxGroup = Checkbox.Group;
const prefixCls = 'ehome-check-all';
class CheckboxWithAll extends (PureComponent || Component) {
	//勾选全部
	onCheckAllChange =(e) => {
		const checked = e.target.checked;
		let selectedNew = [];
		const { onChange, options } = this.props;
		if (checked) {
			selectedNew = options.map(item => item.value);
		}
		onChange && onChange(selectedNew);
	}

	//判断全选框的状态
	judgeCheckAllState = (selecteds) => {
		let indeterminate = false, checkAll = false;
		const { options = [] } = this.props;
		if (selecteds.length > 0 && selecteds.length < options.length) {
			indeterminate = true;
		} else if (selecteds.length === options.length) {
			checkAll = true;
		}
		return { indeterminate, checkAll };
	}

		// 应用勾选与否
		toggleAppChecked = (ids) => {
			const { onChange } = this.props;
			onChange && onChange(ids);
		}

		render() {
			const { readOnly, value: checkedList = [], options: plainOptions = [], checkAllLabel, groupLabel } = this.props;
			const { indeterminate, checkAll } = this.judgeCheckAllState(checkedList);
			return (
				<div className={!groupLabel ? `${prefixCls} ${prefixCls}-border` : prefixCls }>
					<div className={groupLabel ? `${prefixCls}-header-forRole` : `${prefixCls}-header`} >
						{
							groupLabel && <div><span style={{ color: 'red' }}>*</span>{groupLabel}</div>
						}
						<Checkbox disabled={readOnly} indeterminate={indeterminate} onChange={this.onCheckAllChange} checked={checkAll} >
							<span className={readOnly ? '' : prefixCls + '-header-checkAll'} >{checkAllLabel || '全部'}</span>
						</Checkbox>
					</div>
					<div className={groupLabel ? `${prefixCls}-itemList ${prefixCls}-border` : `${prefixCls}-itemList`}>
						<CheckboxGroup disabled={readOnly} options={[...plainOptions]} value={checkedList} onChange={this.toggleAppChecked} />
					</div>
				</div>
			);
		}
}
export default CheckboxWithAll;
